import promo from './promo'
import serviceArea from './service-area'
import serviceTypes from './service-types'
import logs from './logs'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    promo.state,
    serviceArea.state,
    serviceTypes.state,
    logs.state
  ),
  mutations: Object.assign(
    promo.mutations,
    serviceArea.mutations,
    serviceTypes.mutations,
    logs.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/pricing/index.js